import { useCallback } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import type { FacebookFormData } from '../validation/facebookValidator';

export type UseStepRevalidationParams = Pick<
  UseFormReturn<FacebookFormData>,
  'setValue' | 'trigger'
>;

export const useStepRevalidation = ({
  setValue,
  trigger,
}: UseStepRevalidationParams): ((targetStep: number) => Promise<void>) =>
  useCallback(
    async (targetStep: number) => {
      setValue('currentStep', targetStep);
      await trigger();
    },
    [setValue, trigger],
  );

export default useStepRevalidation;
